import React from "react";

const ModalEditInstitution = ({
  isModalOpen,
  handleModalClose,
  posicion,
  setPosicion,
  tag,
  setTag,
  handleUpdate,
  handleDelete,
  handleUpdateAcreditados,
  posicionDirigida,
  setPosicionDirigida,
  grupoDirigido,
  setGrupoDirigido,
  config,
  // FTR-0048: el sync legacy se oculta cuando la importación SISDEU nueva está activa para el evento (company 1).
  showUpdateAcreditados = true,
}) => {
  if (!isModalOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 modal-container"
      onClick={handleModalClose}
    >
      <div
        className="bg-white p-6 rounded-lg shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold mb-4">Actualizar Participante</h2>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Posición</label>
          <input
            type="number"
            value={posicion}
            onChange={(e) => setPosicion(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Tag</label>
          <input
            type="text"
            value={tag}
            onChange={(e) => setTag(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none"
          />
        </div>
        {config && config.useCabezaGrupo && (
          <>
            <hr className="border-t border-gray-300 my-4" />
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Posición Dirigida
              </label>
              <input
                type="number"
                value={posicionDirigida}
                onChange={(e) => setPosicionDirigida(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Grupo Dirigido</label>
              <input
                type="number"
                value={grupoDirigido}
                onChange={(e) => setGrupoDirigido(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none"
              />
            </div>
          </>
        )}

        <div className="flex justify-end mb-4">
          <button
            onClick={handleModalClose}
            className="bg-gray-500 text-white px-4 py-2 rounded mr-2 hover:bg-gray-600 transition duration-300"
          >
            Cancelar
          </button>
          <button
            onClick={handleUpdate}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-300"
          >
            Actualizar
          </button>
        </div>

        {showUpdateAcreditados && (
          <>
            {/* Línea divisoria estilizada */}
            <hr className="border-t border-gray-300 my-4" />

            {/* Botón para actualizar acreditados */}
            <button
              onClick={handleUpdateAcreditados}
              className="w-full bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition duration-300"
            >
              Actualizar Acreditados
            </button>
          </>
        )}

        <hr className="border-t border-gray-300 my-4" />

        <button
          onClick={handleDelete}
          className="w-full bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition duration-300"
        >
          Eliminar Participante
        </button>
      </div>
    </div>
  );
};

export default ModalEditInstitution;
